module.exports = __webpack_public_path__ + "img/tarj4-3.a846f06f.svg";